import * as Phaser from "phaser"

class PhaserGameEventBus {
  private bootstrapEmitter = new Phaser.Events.EventEmitter()
  private game: Phaser.Game | null = null

  public init(game: Phaser.Game): void {
    this.game = game
  }

  private get emitter(): Phaser.Events.EventEmitter {
    return this.game?.events ?? this.bootstrapEmitter
  }

  public on(
    event: string | symbol,
    fn: (...args: never[]) => void,
    context?: unknown,
  ): this {
    this.emitter.on(event, fn, context)
    return this
  }

  public once(
    event: string | symbol,
    fn: (...args: never[]) => void,
    context?: unknown,
  ): this {
    this.emitter.once(event, fn, context)
    return this
  }

  public off(
    event: string | symbol,
    fn?: (...args: never[]) => void,
    context?: unknown,
    once?: boolean,
  ): this {
    this.emitter.off(event, fn, context, once)
    return this
  }

  public emit(event: string | symbol, ...args: unknown[]): boolean {
    return this.emitter.emit(event, ...args)
  }
}

/**
 * Shared gameplay event adapter. Once the game boots it forwards to
 * Phaser's native `game.events` emitter so scenes and systems can keep their
 * current API while using Phaser-managed event plumbing.
 */
export const EventBus = new PhaserGameEventBus()
